<template>
  <v-snackbar
    v-model="snackbar.visible"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
    :multi-line="snackbar.multiline === true"
    top
  >
    {{ snackbar.text }}
    <v-btn flat dark @click="closeSnackbar">Close</v-btn>
  </v-snackbar>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'Snackbar',
  computed: {
    snackbar() {
      return this.$store.getters.snackbar;
    },
  },
  methods: {
    ...mapMutations(['closeSnackbar']),
  },
};
</script>
